import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Home,
  Search,
  Bookmark,
  Award,
} from "lucide-react";
import { useApp } from "../context/AppContext";
import { sapLogo, steadfastLogo } from "../lib/logos";
import { Button } from "./ui/button";
import { Progress } from "./ui/progress";
import GlobalSearch from "./GlobalSearch";

export default function TopNav() {
  const { user, theme, setTheme, percent, allModulesPassed } = useApp();
  const [searchOpen, setSearchOpen] = useState(false);
  const nav = useNavigate();

  return (
    <header
      className="sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur-xl"
      data-testid="top-nav"
    >
      <div className="max-w-7xl mx-auto flex items-center gap-3 px-4 sm:px-6 py-3">
        {/* Steadfast logo left */}
        <Link
          to="/home"
          className="flex items-center gap-2 shrink-0"
          aria-label="Steadfast home"
          data-testid="steadfast-logo-link"
        >
          <img
            src={steadfastLogo}
            alt="Steadfast IT Consulting"
            className="h-10 w-auto"
          />
        </Link>

        <div className="hidden md:block h-6 w-px bg-border mx-2" />

        {/* Course title */}
        <Link
          to="/home"
          className="hidden md:flex flex-col leading-tight"
          data-testid="nav-title-link"
        >
          <span className="serif text-lg text-foreground">SAP: Basics &amp; Fundamentals</span>
          <span className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
            40-hour e-learning course
          </span>
        </Link>

        {/* Progress bar in the middle */}
        {user && (
          <div className="hidden lg:flex items-center gap-3 flex-1 max-w-xs mx-auto" data-testid="nav-progress">
            <span className="mono text-xs text-muted-foreground whitespace-nowrap">
              {percent}% complete
            </span>
            <Progress value={percent} className="h-2 flex-1" />
          </div>
        )}

        <div className="ml-auto flex items-center gap-1 sm:gap-2">
          {user && (
            <>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => nav("/home")}
                data-testid="nav-home-btn"
              >
                <Home className="w-4 h-4 sm:mr-2" />
                <span className="hidden sm:inline">Home</span>
              </Button>

              <Button
                variant="ghost"
                size="sm"
                onClick={() => setSearchOpen(true)}
                data-testid="nav-search-btn"
              >
                <Search className="w-4 h-4 sm:mr-2" />
                <span className="hidden sm:inline">Search</span>
              </Button>

              <Button
                variant="ghost"
                size="sm"
                onClick={() => nav("/bookmarks")}
                data-testid="nav-bookmarks-btn"
              >
                <Bookmark className="w-4 h-4 sm:mr-2" />
                <span className="hidden sm:inline">Saved</span>
              </Button>


            </>
          )}



          {/* SAP logo right */}
          <div className="flex items-center ml-1" aria-label="SAP">
            <img src={sapLogo} alt="SAP" className="h-9 w-auto" data-testid="sap-logo" />
          </div>
        </div>
      </div>

      <GlobalSearch open={searchOpen} onOpenChange={setSearchOpen} />
    </header>
  );
}
